import i18n from "config/i18next";

i18n.addResources("es", "presettlement", {
  history: "Historial",
  transactions: "Transacciones",
  trips: "Viajes",
  transaction: "Transacción",
  changeAmount: "Modificar monto",
  id: "ID",
  date: "Fecha",
  status: "Estado",
  amount: "Monto",
  detailAmount: "Cantidad",
  total: "Total",
  emisionDate: "Fecha de generación",
  fiscalNumber: "Identificador fiscal",
  companyName: "Razón social",
  sapCode: "Código SAP",
  region: "Región",
  initialState: "En generación",
  pending: "Pendiente",
  inApprovement: "En aprobación",
  approved: "Aprobada",
  pendingAcounting: "Pendiente de contabilidad",
  inAcounting: "En contabilidad",
  generatedPayment: "Pago generado",
  invoiceRejected: "Factura rechazada",
  adjustment: "Modificación",
  weekly: "Premio semanal",
  daily: "Premio diario",
  assured: "Asegurado por turno",
  extraPickUpKm: "km por colecta",
  pickUp: "Colecta",
  extraDeliveredKm: "km por entrega",
  delivered: "Entrega exitosa",
  extraReturnedKm: "km por devolución",
  returned: "Devolución",
  rainBonus: "Bonus por lluvia",
  finished: "Finalizado",
});
